import { Controller } from "@hotwired/stimulus"
import { createRoot } from "react-dom/client"
import AuthForm from "../components/AuthForm"

// Mount point for the login / signup screens: hands the server-rendered config
// (mode, action, csrf, param wrapper, cross-link) to the React form.
export default class extends Controller {
  static values = { config: Object }

  connect() {
    this.root = createRoot(this.element)
    this.root.render(<AuthForm config={this.configValue} />)
  }

  disconnect() {
    this.root?.unmount()
  }
}
